module.exports = __webpack_public_path__ + "img/miljo-5.adb00dda.png";